import { Button } from "@mui/material";
import { getSelectedExamInfo } from "modules/platform-components/utils/configuration";
import React, { useState } from "react";

function ManualConfiguration(props) {

  const {
    register,
    getValues,
    errors,
    questionData,
    manualQuestions,
    subjectValue,
    filteredSubject,
    fullQuestions,
    showFullscreen,
    setShowFullscreen,
    showFilter,
    setShowFilter
  } = props;

  return (subjectValue.length > 0 && getSelectedExamInfo().status !== "APPROVED" &&
  getSelectedExamInfo().status !== "PUSHED TO APP" &&
  getSelectedExamInfo().status !== "REJECTED") ? (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {showFilter && (
          <Button
            variant="text"
            style={{ marginRight: "5px" }}
            onClick={() => setShowFullscreen(!showFullscreen)}
          >
            {" "}
            {showFullscreen ? "hide" : "show"} fullscreen
          </Button>
        )}
        {getSelectedExamInfo().status !== "APPROVED" && (
          <Button
            variant="text"
            style={{ margin: "0px" }}
            onClick={() => setShowFilter(!showFilter)}
          >
            {" "}
            {showFilter ? "hide" : "show"} Advanced
          </Button>
        )}
      </div>
      <div className="heading-small">Manual Configuration:</div>
      <div className="">
        <label className="questions-dropdown-label">Total Questions *</label>
        <div className="questions-dropdown-input">
          <input
            className="form-details"
            type="number"
            placeholder="Total Questions"
            name="totalQuestions"
            disabled
            value={manualQuestions.length}
            ref={register({
              required: true,
              validate: (value) =>
                parseInt(value, 10) > 0 &&
                parseInt(value, 10) === manualQuestions?.length,
            })}
          />
          <div class="error-msg">
            {" "}
            {errors?.totalQuestions?.type === "required" &&
              "Total Questions is required"}
            {errors?.totalQuestions?.type === "validate" &&
              parseInt(getValues()?.totalQuestions, 10) === 0 &&
              "Total questions must be greater than zero"}
            {errors?.totalQuestions?.type === "validate" &&
              parseInt(getValues()?.totalQuestions, 10) > 0 &&
              "Selected Questions and Total Question count is not matching"}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {questionData.length > 0 &&
          subjectValue.map((el) => (
            <div style={{ margin: "10px" }}>
              <div>{el.label}</div>
              <div className="form-details" style={{ marginTop: "5px" }}>
                {(filteredSubject.length === 0
                  ? questionData
                  : fullQuestions
                )
                  .filter(
                    (ql) =>
                      (manualQuestions || []).includes(ql.questionId) &&
                      ql.subjectId === el.value
                  )
                  .length}{" "}
              </div>
            </div>
          ))}
      </div>
    </>
  ) : null;
}

export default ManualConfiguration;
